import { Controller } from "@hotwired/stimulus"

// Toggles a native <dialog> element. Use data-controller="dialog", data-dialog-target="dialog",
// and data-action="click->dialog#open" / "click->dialog#close".
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }
}
